import styled, { css } from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { interactiveTransition } from '../../foundation/theme/utils.js';
import { Typography } from '../../foundation/Typography/styled.js';

var flexStyles = css(["display:flex;justify-content:center;align-items:center;column-gap:", ";"], themeGet('spacing.md'));
var buttonBase = css(["appearance:none;text-decoration:none;box-sizing:border-box;font-style:normal;font-weight:", ";font-size:", ";line-height:", ";border-style:solid;border-width:", ";border-radius:", ";width:", ";", ";&:not(:disabled){cursor:pointer;}&:focus-visible{outline:none;}", ";"], themeGet('fontWeight.medium'), themeGet('fontSize.medium'), themeGet('lineHeight.default'), pxToRem(1), themeGet('borderRadius.md'), function (props) {
  return props.$stretch ? "100%;" : "fit-content;";
}, flexStyles, interactiveTransition);
styled(Typography).withConfig({
  displayName: "StyledTypography",
  componentId: "sc-u08eyn-0"
})(["", ""], flexStyles);

export { buttonBase };
